import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

export const useRequestPayTransaction = () => {

    const { invalidate } = useInvalidateQueries();
    const { isPending, error, mutateAsync } = useMutation({
        mutationKey: [routes.api.transactions, 'pay'],
        mutationFn: (id: string) =>
            apiClient
                .post<void>(routes.api.payTransaction(id), {})
                .then(handleApiResponse),
        onSuccess: () => (
            Promise
                .all([
                    invalidate(routes.api.transactions),
                ])
        )
    });

    const payTransaction = (id: string) =>
        mutateAsync(id);

    return ({
        isLoading: isPending,
        payTransaction,
        error
    });

};
